export default "__VITE_ASSET__DFB_GS84__"